import script from "./FooterSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterSection.vue?vue&type=script&setup=true&lang=js"

import "./FooterSection.vue?vue&type=style&index=0&id=32f82cd5&lang=scss"

const __exports__ = script;

export default __exports__